const localization = {
    cannot_delete_default_language: '{{languageTag}} varsayılan dil olarak ayarlanmıştır ve silinemez.',
    invalid_translation_structure: 'Geçersiz veri şemaları. Lütfen girdilerinizi kontrol edin ve tekrar deneyin.',
};
export default Object.freeze(localization);
